<template>
    <div class="page_box">
        <van-image class="form_logo" :src="require('../assets/form_logo@2x.png')"></van-image>
        <van-form @submit="onSubmit">
            <div class="form_title">邀请码：{{queryParams.parentInviteCode}}</div>
            <van-field
                v-model="queryParams.agentName"
                name="公司名称"
                placeholder="公司名称(企业填单位,个人填姓名)"
                :left-icon="require('../assets/form_icon_01@2x.png')"
            />
            <van-field
                v-model="queryParams.agentAccount"
                name="手机号"
                placeholder="请输入手机号"
                :left-icon="require('../assets/form_icon_02@2x.png')"
            />
            <van-field
                v-model="queryParams.password"
                name="密码"
                placeholder="请输入密码"
                :left-icon="require('../assets/form_icon_03@2x.png')"
            />
            <van-field
                v-model="queryParams.smsCode"
                name="验证码"
                placeholder="请输入验证码"
                :left-icon="require('../assets/form_icon_04@2x.png')"
            >
                <template #button>
                    <span @click="getCode">{{codeText}}</span>
                </template>
            </van-field>
            <van-checkbox v-model="checked" shape="square" icon-size="12px" label-disabled checked-color="#AC1F25">
                <p :class="checked == true ? 'checkbox-show color-true' : 'checkbox-show'">
                    我已查看并同意
                    <span @click="$router.push('/platformB/richText?type=1')">《用户注册协议》</span>
                    和
                    <span @click="$router.push('/platformB/richText?type=2')">《用户隐私》</span>
                </p>
            </van-checkbox>
            <van-button class="submit_btn" native-type="submit">代理注册</van-button>
            <div class="page_button_text" @click="$router.push('/platformB')">已注册用户可点击<span>下载APP</span></div>
        </van-form>
    </div>
</template>

<script>
    import { getSmsCode, agentRegisterCode, agentRegisterUser } from '@/api/index'
    export default {
        data() {
            return {
                queryParams : {
                    agentName: '',
                    agentAccount: '',
                    password: '',
                    smsCode: '',
                    parentInviteCode: ''
                },
                checked: true,
                code: this.GetQueryString('id'),
                codeText: '点击获取',
            }
        },
        created(){
            this.agentRegisterCode();
        },
        methods: {
            // ID 换取 邀请码
            agentRegisterCode(){
                agentRegisterCode({ id: this.code }).then(res => {
                    this.queryParams.parentInviteCode = res.data.parentInviteCode;
                })
            },
            // 获取参数
            GetQueryString(name){
                var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
                var r = window.location.search.substr(1).match(reg);
                if(r!=null)return  unescape(r[2]); return null;
            },
            // 倒计时
            getCode(){
                if(!this.queryParams.agentAccount){
                    this.$toast('手机号码不能为空');
                    return
                }
                if(this.codeText == '点击获取'){
                    var that = this;
                    that.codeText=60;
                    that.getSmsCode();
                    var timeClock=setInterval(function(){
                        that.codeText--;
                        if (that.codeText == 0) {
                            clearInterval(timeClock);
                            that.codeText = '点击获取'
                        } 
                    },1000)
                }
            },
            // 获取验证码
            getSmsCode(){
                getSmsCode({ agentAccount: this.queryParams.agentAccount, smsType: 'register' }).then(res => {
                    this.$toast(res.msg)
                })
            },
            onSubmit(value) {
                for(let i in value) {
                    if(!value[i]) {
                        this.$toast('请输入' + i);
                        return
                    }
                }
                agentRegisterUser(this.queryParams).then(res => {
                    this.$dialog.alert({
                        message: '注册成功，请前往下载！',
                    }).then(() => {
                        this.goPage('/platformB');
                    });
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.page_box {
    background: url('../assets/formBackground@2x.png');
    background-size: 100% auto;
    background-repeat: no-repeat;
    width: 100vw;
    min-height: 100vh;
    display: flex;
    align-items: center;
    flex-direction: column;
}
.form_logo{ 
    width: 207px;
    margin: 33px 0 40px 0;
}
.van-form {
    width: 338px;
    height: 529px;
    background: white;
    border-radius: 10px 10px 10px 10px;
    margin-bottom: 63px;
    display: flex;
    align-items: center;
    flex-direction: column;
    .form_title {
        font-size: 16px;
        font-weight: 500;
        color: #AC1F25;
        margin-top: 35px;
        margin-bottom: 40px;
    }
    .van-field {
        width: 300px;
        height: 52px;
        background: #FFFFFF;
        border-radius: 8px 8px 8px 8px;
        opacity: 1;
        border: 1px solid #E8E8E8;
        display: flex;
        align-items: center;
        flex-direction: row;
        margin-bottom: 12px;
        /deep/ .van-field__left-icon {
            width: 20px;
            margin-top: 3px;
        }
    }
    .van-checkbox{
        width: 80vw;
        margin-left: 5vw;
        font-size: 12px;
        .checkbox-show{
            margin: 0;
            span{
                color: red;
            }
        }
        .color-true{
            color: black;
        }
    }
}
.submit_btn {
    width: 280px;
    height: 40px;
    background: #AC1F25;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    border: 1px solid #AC1F25;
    font-size: 14px;
    font-weight: 500;
    color: #FFFFFF;
    margin-top: 47px;
}
.page_button_text{
    font-size: 14px;
    font-weight: 500;
    margin-top: 13px;
    span {
        color: #AC1F25;;
    }
}
</style>